export default __webpack_public_path__ + "static/media/img_1.40d41a63.jpg";